export default "__VITE_ASSET__GraT1VTt__"